'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));

  const startMeeting = () => {
    const roomUrl = `/rooms/${generateRoomId()}`;
    router.push(e2ee ? `${roomUrl}#${encodePassphrase(sharedPassphrase)}` : roomUrl);
  };

  return (
    <main lang="ru" className={styles.landing} data-lk-theme="default">
      <section className={styles.brand} aria-labelledby="landing-title">
        <Image
          className={styles.logo}
          src="/images/space-rooms-logo.png"
          alt="Space Rooms"
          width={324}
          height={107}
        />
        <h1 id="landing-title" className={styles.title}>
          Видеовстречи в Space Rooms
        </h1>
        <p className={styles.subtitle}>Создавайте защищённые видеовстречи прямо в браузере.</p>
      </section>

      <div className={styles.actions}>
        <button className={styles.primaryButton} type="button" onClick={startMeeting}>
          Начать встречу
        </button>
      </div>

      <details className={styles.advancedSettings}>
        <summary>Дополнительные настройки</summary>
        <div className={styles.encryptionSettings}>
          <label className={styles.checkboxLabel} htmlFor="use-e2ee">
            <input
              id="use-e2ee"
              type="checkbox"
              checked={e2ee}
              onChange={(event) => setE2ee(event.target.checked)}
            />
            <span>Сквозное шифрование</span>
          </label>
          <p className={styles.helperText}>
            Дополнительная защита встречи с помощью сквозного шифрования.
          </p>
          {e2ee && (
            <label className={styles.passphraseLabel} htmlFor="passphrase">
              <span>Ключ шифрования</span>
              <input
                id="passphrase"
                type="password"
                value={sharedPassphrase}
                onChange={(event) => setSharedPassphrase(event.target.value)}
              />
            </label>
          )}
        </div>
      </details>
    </main>
  );
}
